import React from 'react';
import priontoFull from '../images/priontoFull.png';
import './../index.css';

const About = () => {
  return (
    <section className='about' name='about' id='about'>
      <div className='container'>
        <div className='common pt-5' data-aos='fade-up'>
          <h2 className='mainHeader mt-5'>About Me</h2>
          <p className='mainContent'>
            Building scalable web applications and AI-driven automation
            platforms, with a focus on performance, reliability, and clean
            architecture.
          </p>
          <div className='commonBorder' />
        </div>

        <div className='row alignCenter' data-aos='fade-up'>
          <div className='col-md-4'>
            <div className='about-img'>
              <img
                src={priontoFull}
                alt='Prionto Abdullah, Senior Software Engineer'
              />
            </div>
          </div>
          <div className='col-md-8'>
            <div className='info'>
              <h3>
                Hi There
                <span role='img' aria-label='Hand waving' className='ml-2'>
                  ✌
                </span>
              </h3>
              <div className='info-p1'>
                I'm a Senior Software Engineer with 4+ years of experience
                building scalable web applications and AI-driven automation
                platforms. I currently lead engineering efforts at
                Markopolo.ai on Autonomous Revenue Agents and MarkTag, a
                cookieless first-party tracking system.
              </div>
              <div className='info-p1'>
                I'm proficient in React, Next.js, Node.js, NestJS,
                TypeScript, Redux Toolkit, Express.js, MongoDB, and
                PostgreSQL, with a focus on performance, reliability, and
                clean architecture.
              </div>
              <div className='info-p2'>
                I have a track record of improving data accuracy, system
                performance, and team productivity through technical
                leadership and mentorship, and I'm always open to
                conversations about AI automation, scalable system design, or
                new challenges.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
